import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";

export const HIDE_STICKY_ON = [/^\/location\/caution\//, /^\/paiement-acompte\//];

export default function StickyCTA() {
  const { pathname } = useLocation();
  if (HIDE_STICKY_ON.some((r) => r.test(pathname))) return null;
  return (
    <div className="lg:hidden fixed bottom-4 left-4 right-[5.25rem] z-40 flex gap-2" style={{ bottom: "max(1rem, env(safe-area-inset-bottom))" }} data-testid="sticky-cta">
      <a
        href="tel:0769224956"
        data-testid="sticky-call-btn"
        className="btn-ghost-gold flex-1 !py-3 !text-[11px] backdrop-blur bg-black/70"
      >
        <Phone size={14} strokeWidth={1.4} /> Appeler
      </a>
      <Link
        to="/contact"
        data-testid="sticky-devis-btn"
        className="btn-gold flex-1 !py-3 !text-[11px]"
      >
        Devis gratuit
      </Link>
    </div>
  );
}
